import { render, staticRenderFns } from "./QualificationList.vue?vue&type=template&id=099defd5&scoped=true"
import script from "./QualificationList.vue?vue&type=script&lang=js"
export * from "./QualificationList.vue?vue&type=script&lang=js"
import style0 from "./QualificationList.vue?vue&type=style&index=0&id=099defd5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099defd5",
  null
  
)

export default component.exports